import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import Reducer from './redux-store/reducer/redux-reducer';
import AuthReducer from './redux-store/reducer/auth-reducer';

// Kind of Global Variable  for State(react context)
import { createStore , applyMiddleware , combineReducers , compose} from 'redux';

// utility library for linking standalone redux with react
// Provider will connect global store(state) with out project
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';

const reducer = combineReducers({Reducer : Reducer , AuthReducer : AuthReducer});
const composeEnhancers = process.env.NODE_ENV === 'development' ? 
                  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__  : null || compose;
const storeInstance = createStore(reducer, composeEnhancers(applyMiddleware(thunk)));

ReactDOM.render(
  <React.StrictMode>
    <Provider store={storeInstance}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
